export default __webpack_public_path__ + "media/foster.809dd625.png";